// Numbers start at 1 on each page load, in the order participants first
// appear, so "Participant 2" is the same participant on every screen until
// the next reload.
const numbers = new Map<string, number>()

export function demoNumber(participantId: string): number {
  let n = numbers.get(participantId)
  if (n === undefined) {
    n = numbers.size + 1
    numbers.set(participantId, n)
  }
  return n
}

export function demoParticipantLabel(participantId: string): string {
  return `Participant ${demoNumber(participantId)}`
}

export function resetDemoNumbers(): void {
  numbers.clear()
}
